import type { ContactOrderPostalSelection } from "../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderAppointmentRow } from "../../../_logic/contact-orders-contract"
import type { PostalRecipientFormValue } from "../../postal-recipient-form"
import { postalRecipientPresentation } from "../_shared/_logic/postal-presentation"
import type { PlanningRendererPorts } from "./openPlanningEditors"

type PostalEditContext = {
  organizationId: string
  row: ContactOrderAppointmentRow | undefined
  selection: ContactOrderPostalSelection
  enabled: boolean
  editable: boolean
}

export const editPostalRecipient = ({
  organizationId,
  row,
  original,
  enabled,
  property,
  individual,
  dispatch,
  current,
  apply,
  open,
}: {
  organizationId: string
  row: ContactOrderAppointmentRow
  original: ContactOrderPostalSelection
  enabled: boolean
  property?: Property
  individual: boolean
  dispatch?: "MANUAL" | "AUTOMATIC"
  current: () => PostalEditContext
  apply: (row: ContactOrderAppointmentRow, postal: ContactOrderPostalSelection) => void
  open: PlanningRendererPorts["openPostalRecipientEditor"]
}) => {
  if (!individual && original.mode !== "PERSONAL") return

  const key = JSON.stringify(original)
  const recipient = postalRecipientPresentation(original, row.planningPreview)
  const address = recipient.address ?? property
  const manual = individual || Boolean(original.manual_recipient)
  open({
    manual,
    initialValue: {
      recipientName: individual && !original.manual_recipient ? "" : recipient.name,
      country: address?.country ?? "Deutschland",
      street: address?.street ?? "",
      house_number: address?.house_number ?? "",
      zip: address?.zip ?? "",
      city: address?.city ?? "",
      address_extra: address?.address_extra ?? "",
    },
    onApply: (value: PostalRecipientFormValue) => {
      const next = current()

      if (
        !next.editable ||
        next.organizationId !== organizationId ||
        !next.row ||
        JSON.stringify(next.selection) !== key ||
        next.enabled !== enabled
      ) {
        return "Die Auswahl wurde inzwischen geändert. Bitte die Bearbeitung erneut öffnen."
      }

      const postal: ContactOrderPostalSelection = manual
        ? {
            mode: "PERSONAL",
            manual_recipient: {
              name: value.recipientName.trim(),
              address: {
                country: value.country.trim(),
                street: value.street.trim(),
                house_number: value.house_number.trim(),
                zip: value.zip.trim(),
                city: value.city.trim(),
                address_extra: value.address_extra?.trim() || null,
              },
            },
            dispatch_mode:
              dispatch ??
              (original.mode === "PERSONAL" ? (original.dispatch_mode ?? "MANUAL") : "MANUAL"),
          }
        : { ...original, recipient_name: value.recipientName.trim() }
      apply(next.row, postal)

      return null
    },
  })
}
